export function Footer() {
  return(
    <footer className="center">
  <p>Favicon created by Prosymbols Premium - Flaticon</p>
  </footer>
  )
}